import React from 'react';
import styles from './Card.module.css';
import {
	iconThumbUp,
	iconThumbDown,
	iconProgressDown,
	iconProgressUp,
	iconScales
} from '../../../../../Components/CustomIcon/CustomIcon.js';

const CardIcon = ({
	favorableness,
	findingType
}) => {

	const Icon = () => {
		if(findingType === 'BigUplift') return iconProgressUp;
		if(findingType === 'SmallUplift') return iconProgressUp;
		if(findingType === 'SmallFall') return iconProgressDown;
		if(findingType === 'BigFall') return iconProgressDown;
		if(findingType === 'ProductPositiveSpotlight') return iconThumbUp;
		if(findingType === 'ProductTopList') return iconThumbUp;
		if(findingType === 'ProductNegativeSpotlight') return iconThumbDown;
		if(findingType === 'ProductFlopList') return iconThumbDown;
		if(findingType === 'PositiveBusinessComparison' || findingType === 'NegativeBusinessComparison') return iconScales;
	};
	
	const cssClass = [styles.icon];
	if (favorableness !== -1) {
		cssClass.push(styles.color_success);
	} else {
		cssClass.push(styles.color_alert);
	}

	return (
		<span className={cssClass.join(' ')}>
			{Icon()}
		</span>
	);
};

export default CardIcon;